import React from 'react';
import Loader from "react-js-loader";
import { tokens } from '../theme';
import { useTheme } from '@mui/material';

const LoaderSpinner = ({ loading }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <>
            {loading && (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    width: '100%',
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    backgroundColor: `${colors.grey[100]}80`,
                    zIndex: 9999,
                    backdropFilter: 'blur(5px)', // Added blur effect
                    WebkitBackdropFilter: 'blur(5px)', // For Safari support
                    pointerEvents: 'none', // do not block clicks on underlying UI
                }}>
                    <Loader type="bubble-spin" bgColor={colors.secondary[500]} size={50} />
                </div>
            )}
        </>
    );
};

export default LoaderSpinner;
